import React from 'react';

const styles = {
  container:{
    position: 'fixed',
    width: '100%',
    height: '100%',
    left: '0',
    top: 0,
    background: '#fff',
    zIndex: 9999
  },
  loader: {
    position: 'absolute',
    top: '50%',
    left: '50%',
  }
}

class Loader extends React.Component {	
  constructor(props){
    super(props);
  }
  render() {
    return (
      <div className="fullW" style={styles.container}><div id="loader"></div></div>
    );
  }
}
export default Loader;


// WEBPACK FOOTER //
// ./src/components/Loader.js